import { useQuery } from '@tanstack/react-query';

import { CerberusApi } from '@hcs/cerberus';
import {
  ZipHpiTimeSeriesDocument,
  ZipHpiTimeSeriesQuery,
  ZipHpiTimeSeriesQueryVariables,
} from '@hcs/types';

import { zipHpiTSQueryToCerberusHpiTS } from '../utils/cerberus-stats.utils';

const QUERY_KEY_ZIP_HPI_TIME_SERIES = 'zip-hpi-time-series';

export const useZipHpiTimeSeries = ({
  zipcode,
  fromDate,
  toDate,
  enabled = true,
}: ZipHpiTimeSeriesQueryVariables & {
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [QUERY_KEY_ZIP_HPI_TIME_SERIES, zipcode, fromDate, toDate],

    queryFn: async () => {
      const response = await CerberusApi.fetchQuery<
        ZipHpiTimeSeriesQuery,
        ZipHpiTimeSeriesQueryVariables
      >(ZipHpiTimeSeriesDocument, {
        zipcode,
        fromDate,
        toDate,
      });
      return zipHpiTSQueryToCerberusHpiTS(response);
    },

    enabled,
  });
};
